import { MedicamentPrintLabelDto, PatientPrintLabelDto, PrintLabelDto } from 'ts-types/api.types';

export enum ChromeExtensionStatus {
  NO_EXTENSION = 'NO_EXTENSION',
  OUTDATED_EXTENSION = 'OUTDATED_EXTENSION',
  NO_HOST_APPLICATION = 'NO_HOST_APPLICATION',
  OUTDATED_HOST_APP = 'OUTDATED_HOST_APP',
  OK = 'OK'
}

const getChromeRuntime = function (): any {
  let w = window as any;
  if (w.chrome && w.chrome.runtime) {
    return w.chrome.runtime;
  }
  return undefined;
}

const createNativeApi = function (aExtensionId?: string) {

  const chromeRuntime = getChromeRuntime();
  const extInfoEl = document.getElementById("extinfo-pmednativetools") as HTMLInputElement;
  if (!chromeRuntime || !extInfoEl) {
    return undefined;
  }

  const extensionId = aExtensionId || extInfoEl.value;

  const MESSAGE_READ_CARD = 'readCard';
  const GET_EXTENSION_VERSION = 'getExtensionVersion';
  const IS_HOST_PRESENT = 'isHostPresent';
  const READ_PRINTERS = 'readPrinters';
  const PRINT_FILE = 'printFile';

  const MESSAGE_READ_CARD_TEST = 'readCardTest';

  class Api {
    readCard(callback: any) {
      chromeRuntime.sendMessage(extensionId, {command: MESSAGE_READ_CARD}, callback);
    }

    getExtensionVersion(callback: any) {
      chromeRuntime.sendMessage(extensionId, {message: GET_EXTENSION_VERSION}, callback);
    }

    isHostPresent(callback: any) {
      chromeRuntime.sendMessage(extensionId, {command: IS_HOST_PRESENT}, callback);
    }

    readPrinters(callback: any) {
      chromeRuntime.sendMessage(extensionId, {command: READ_PRINTERS}, callback);
    }

    printFile(data: any, printConfiguration: any, callback: any) {
      chromeRuntime.sendMessage(
          extensionId,
          {command: PRINT_FILE, payload: {printConfiguration: printConfiguration, data: data}},
          callback
      );
    }

    readCardTest(callback: any) {
      chromeRuntime.sendMessage(extensionId, {command: MESSAGE_READ_CARD_TEST}, callback);
    }
  }

  return new Api();
}

const nativeToolsAPI = (): any => {
  // @ts-ignore
  return createNativeApi();
}

const getExtensionVersion = (): Promise<string> => {
  return new Promise((resolve, reject) => {
    // @ts-ignore
    nativeToolsAPI().getExtensionVersion(res => {
      const extensionVersion = res.version;
      resolve(extensionVersion);
    });
  });
};

const getHostAppVersion = (): Promise<string | null> => {
  return new Promise((resolve, reject) => {
    // @ts-ignore
    nativeToolsAPI().isHostPresent(res => {
      if (res) {
        resolve(res.payload.version);
      }
      resolve(null);
    });
  });
};

export class Version {

  private readonly arr: number[];

  constructor(s: string) {
    this.arr = s.split('.').map(Number);
  }

  compareTo = (v: any) => {
    let i, r = 0, l = Math.max(this.arr.length, v.arr.length);

    for (i = 0; !r && i < l; i++) {
      r = (this.arr[i] || 0) - (v.arr[i] || 0);
    }

    if (r) {
      return r < 0 ? 1 : 0
    }

    return 1;
  }

}

const checkAppVersion = (ver1: string, ver2: string) => {
  const requiredVersion = new Version(ver1);
  const userVersion = new Version(ver2);

  return requiredVersion.compareTo(userVersion);
}

export const getChromeExtensionStatus = async (config: any): Promise<string> => {

  // @ts-ignore
  const praxmedicNativeToolsAPI = createNativeApi();

  if (praxmedicNativeToolsAPI === null || praxmedicNativeToolsAPI === undefined) {
    return ChromeExtensionStatus.NO_EXTENSION;
  }

  const extVersion: string = await getExtensionVersion();
  if (!checkAppVersion(config.requiredChromeExtensionVersion, extVersion)) {
    return ChromeExtensionStatus.OUTDATED_EXTENSION;
  }

  const hostVersion: string | null = await getHostAppVersion();
  if (!hostVersion) {
    return ChromeExtensionStatus.NO_HOST_APPLICATION;
  } else if (!checkAppVersion(config.requiredHostApplicationVersion, hostVersion)) {
    return ChromeExtensionStatus.OUTDATED_HOST_APP;
  }

  return ChromeExtensionStatus.OK;
};

export const readHealthCard = async (): Promise<any> => {
  return new Promise((resolve, reject) => {
    // @ts-ignore
    nativeToolsAPI().readCard(res => {
      resolve(res);
    });
  });
};

// export const readHealthCardTest = async () : Promise<any> => {
//   return new Promise((resolve, reject) => {
//     // @ts-ignore
//     nativeToolsAPI().readCardTest(res => {
//       resolve(res);
//     });
//   });
// };

export const getPrinters = async (): Promise<any> => {
  return new Promise((resolve, reject) => {
    // @ts-ignore
    nativeToolsAPI().readPrinters(res => {
      resolve(res);
    });
  });
};

export const printDocument = async (printLabelDto: PatientPrintLabelDto, printerName: string): Promise<any> => {
  return new Promise((resolve, reject) => {
    // @ts-ignore
    nativeToolsAPI().printFile(printLabelDto.labelBody, {printerName}, res => {
      resolve(res);
    });
  });
};

export const printLabelDocument = async (printLabelDto: PrintLabelDto, printerName: string): Promise<any> => {
  return new Promise((resolve, reject) => {
    // @ts-ignore
    nativeToolsAPI().printFile(printLabelDto.labelBody, {printerName}, res => {
      resolve(res);
    });
  });
};

export const printPatientMedicamentLabel = async (medicamentLabelDto: MedicamentPrintLabelDto, printerName: string):
    Promise<any> => {

  return new Promise((resolve, reject) => {
    // @ts-ignore
    nativeToolsAPI().printFile(medicamentLabelDto.labelBody, {printerName}, res => {
      resolve(res);
    });
  });
};
